import { iSeatzSmartfillLogic } from './iSeatzSmartfillLogic';

export const logic = [iSeatzSmartfillLogic];
